/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Groups_AvailableInputs */



/**
* | output |
* | --- |
* | "No groups available" |
*
* @param {Team_Manager_No_Groups_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_groups_available = /** @type {((inputs?: Team_Manager_No_Groups_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Groups_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe disponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Gruppen verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы недоступны")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay grupos disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无分组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なグループはありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई समूह उपलब्ध नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há grupos disponíveis")
	return /** @type {LocalizedString} */ ("No groups available")
});